import { ControlTypes } from '@nx-customer-apps/shared/enums';
import { QuestionGroupBase } from './question-group-base.model';
import { TextboxQuestion } from './textbox.model';

export class MultiTextbox extends QuestionGroupBase<TextboxQuestion[]> {
    override controlType = ControlTypes.MultiTextbox;
}
